var map = {
	"./apeach/apeach1.png": "0Jmr",
	"./apeach/apeach2.png": "9tW5",
	"./apeach/apeach3.png": "kFgR",
	"./apeach/apeach4.png": "ZkaV",
	"./apeach/apeach5.png": "HKK1",
	"./audio/bgm_apeach.mp3": "jpPe",
	"./audio/btn_click.ogg": "gVdc",
	"./audio/buyButtonSound.ogg": "IJpz",
	"./audio/countdown.ogg": "5bUS",
	"./audio/sellButtonSound.ogg": "KsG9",
	"./background/stage1.png": "LZYX",
	"./background/stage2.png": "Ezrk",
	"./background/stage3.png": "72CJ",
	"./bgimage.png": "5mc7",
	"./brocoli.png": "SgdI",
	"./externalComponent/vuetrend": "NWjG",
	"./externalComponent/vuetrend.js": "NWjG",
	"./fail.png": "YOia",
	"./game-logo.png": "RGdE",
	"./game-title.png": "CId1",
	"./gamza.png": "l0fI",
	"./graph-background.png": "qULD",
	"./guide.png": "XEzK",
	"./logo.png": "7Otq",
	"./money.png": "lYLx",
	"./riding-apeach.png": "jSZ1",
	"./score_board.png": "aCCN",
	"./story.png": "TueI",
	"./success.png": "mzrL",
	"./title.png": "99RW",
	"./tomato.png": "e7/d"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1